const unescapeChars = string =>
  string && string.length > 0
    ? string
        .replace(/&nbsp;/g, ' ')
        .replace(/&#39;/g, "'")
        .replace(/&amp;#39;/g, "'")
        .replace(/&quot;/g, '"')
        .replace(/&amp;quot;/g, '"')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&aacute;/g, 'á')
        .replace(/&Aacute;/g, 'Á')
        .replace(/&eacute;/g, 'é')
        .replace(/&Eacute;/g, 'É')
        .replace(/&iacute;/g, 'í')
        .replace(/&Iacute;/g, 'Í')
        .replace(/&oacute;/g, 'ó')
        .replace(/&Oacute;/g, 'Ó')
        .replace(/&uacute;/g, 'ú')
        .replace(/&Uacute;/g, 'Ú')
        .replace(/&ntilde;/g, 'ñ')
        .replace(/&Ntilde;/g, 'Ñ')
        .replace(/&iquest;/g, '¿')
        .replace(/&quest;/g, '?')
        .replace(/&iexcl;/g, '¡')
        .replace(/&excl;/g, '!')
    : string;

export default unescapeChars;
